<div class="sidebar-layout">
  <!-- Header Mobile -->
  <header class="mobile-header" *ngIf="isMobile">
    <div class="header-content">
      <button
        mat-icon-button
        class="menu-trigger"
        (click)="toggleDrawer()"
        [attr.aria-expanded]="isDrawerOpen"
        [attr.aria-label]="isDrawerOpen ? 'Fechar menu' : 'Abrir menu'"
        matTooltip="Menu de navegação"
        matTooltipPosition="below"
      >
        <mat-icon>{{ isDrawerOpen ? "close" : "menu" }}</mat-icon>
      </button>

      <div class="header-title">
        <h1>Merito</h1>
      </div>

      <div class="header-user">
        <span class="user-name-mobile">{{ personName }}</span>
        <div class="user-avatar-mobile">
          <img *ngIf="personPicture" [src]="personPicture" alt="Foto do usuário" />
          <mat-icon *ngIf="!personPicture">person</mat-icon>
        </div>
      </div>
    </div>
  </header>

  <!-- Drawer Overlay -->
  <div
    class="drawer-overlay"
    *ngIf="isDrawerOpen && isMobile"
    (click)="closeDrawer()"
    [attr.aria-hidden]="!isDrawerOpen"
  ></div>

  <!-- Sidebar -->
  <aside
    class="sidebar"
    [class.drawer-open]="isDrawerOpen"
    role="navigation"
    aria-label="Menu de navegação"
    [attr.aria-hidden]="isMobile && !isDrawerOpen"
    [attr.aria-expanded]="isDrawerOpen"
  >
    <!-- Cabeçalho do Sidebar -->
    <div class="sidebar-header">
      <div class="user-info" *ngIf="personName">
        <div class="user-avatar">
          <img *ngIf="personPicture" [src]="personPicture" alt="Foto do Usuário" class="user-photo" />
          <div class="user-photo-placeholder" *ngIf="!personPicture">
            <mat-icon>person</mat-icon>
          </div>
        </div>
        <div class="user-details">
          <span class="user-name">{{ personName }}</span>
          <p class="user-role">{{ personRole }}</p>
          <div class="company-info" *ngIf="selectedCompanyName">
            <div class="company-selector-container">
              <button
                mat-button
                class="company-selector"
                [matMenuTriggerFor]="companyMenu"
                matTooltip="Trocar empresa"
                matTooltipPosition="below"
              >
                <div class="company-selector-content">
                  <span class="company-name">{{ truncateText(selectedCompanyName, 15) }}</span>
                  <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
                </div>
              </button>

              <!-- Menu de empresas -->
              <mat-menu #companyMenu="matMenu" class="company-menu">
                <button
                  mat-menu-item
                  *ngFor="let company of availableCompanies"
                  (click)="selectCompany(company.id)"
                  [class.selected]="company.id === selectedCompanyId"
                  class="company-menu-item"
                >
                  <span class="company-item-name">{{ company.name }}</span>
                  <mat-icon *ngIf="company.id === selectedCompanyId" class="check-icon">check</mat-icon>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Menu de navegação -->
    <nav class="sidebar-nav">
      <ul>
        <li *ngFor="let item of navItems">
          <a
            [routerLink]="item.route"
            (click)="closeDrawer()"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            <mat-icon>{{ getMaterialIcon(item.icon) }}</mat-icon>
            <span>{{ item.label }}</span>
          </a>
        </li>
      </ul>
    </nav>

    <!-- Botão de Logout -->
    <button
      mat-raised-button
      color="warn"
      class="logout-btn"
      (click)="logout()"
      matTooltip="Sair da aplicação"
      matTooltipPosition="above"
    >
      <span>Sair</span>
    </button>
  </aside>

  <!-- Área principal de conteúdo -->
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
